
import { defineComponent, toRefs, computed } from "vue";
import { useStore } from "vuex";
import {
  ISelectOption,
  useLocationPackagesSelect
} from "@/hooks/esim/location-packages/modules/useLocationPackagesSelect";
import SelectInput from "@/components/Form/SelectInput.vue";

export default defineComponent({
  name: "SelectValidityType",
  components: { SelectInput },
  props: {
    selectedValidityTypeId: { type: Number, default: -1 }
  },
  emits: { select: null },

  setup(props, { emit }) {
    const store = useStore();

    store.dispatch("fetchValidityTypes");

    const { selectedValidityTypeId } = toRefs(props);

    const validityTypes = computed(() => store.getters.validityTypes);

    const { optionsList, selectOption } = useLocationPackagesSelect({
      parentSelectedOptionId: selectedValidityTypeId,
      initialOptions: validityTypes,
      onOptionChanged(option: ISelectOption) {
        emit("select", option);
      }
    });

    return { optionsList, selectOption };
  }
});
